import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { EmploymentStatusListComponent } from './list/list.component';
import { AuthGuard } from '../auth/auth.guard';
import { EmploymentStatusService } from './employment-status.service';
import { SharedModule } from '../shared/shared.module';
import { EmploymentStatusCreateComponent } from './create/create.component';
import { EmploymentStatusFormComponent } from './form/form.component';
import { EmploymentStatusEditComponent } from './edit/edit.component';

const routes: Routes = [
  {
    path: 'employment-statuses',
    component: EmploymentStatusListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'employment-statuses/create',
    component: EmploymentStatusCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'employment-statuses/:id/edit',
    component: EmploymentStatusEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    EmploymentStatusListComponent,
    EmploymentStatusCreateComponent,
    EmploymentStatusFormComponent,
    EmploymentStatusEditComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, EmploymentStatusService],
})
export class EmploymentStatusRoutingModule {
}
